module.exports = __webpack_public_path__ + "static/media/Tô Tiến Vũ‎ 02.1dcf8860.jpg";